import React from 'react';
/**
 * @param {string} title - text for label
 * @param {string} name - name for input
 */
export const Checkbox = React.forwardRef(
  (
    {
      isError,
      focus,
      title,
      note,
      error,
      //  "data-country": dataCountry,
      ...restProps
    },
    ref
  ) => (
    <label className="checkbox">
      <input
        // defaultChecked
        {...restProps}
        type="checkbox"
        className="container-input"
        // onChange={onChange}

        ref={ref}
      />
      <span
        className="text"
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      />
      <span className="checkmark" />
    </label>
  )
);
